<section class="bg-light p-3 rounded">
  <h3 class="text-center mb-3">Login</h3>

  <div
    class="alert alert-danger"
    *ngIf="authService.errorMessage$ | async as errorMessage">
    {{ errorMessage }}
  </div>

  <div
    class="alert alert-warning"
    *ngIf="message">
    {{ message }}
  </div>

  <form
    name="loginForm"
    [formGroup]="formLogin"
    novalidate>
    <div class="mb-3">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input
          matInput
          formControlName="email" />
        <mat-icon
          matSuffix
          class="secondary-text"
          >mail</mat-icon
        >
        <mat-error *ngIf="formLogin.get('email').hasError('required')"> Email is required </mat-error>
        <mat-error *ngIf="!formLogin.get('email').hasError('required') && formLogin.get('email').hasError('email')">
          Please enter a valid email address
        </mat-error>
      </mat-form-field>
    </div>

    <div class="mb-3">
      <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>
        <input
          matInput
          type="password"
          formControlName="password" />
        <mat-icon
          matSuffix
          class="secondary-text"
          >vpn_key</mat-icon
        >
        <mat-error *ngIf="formLogin.get('password').hasError('required')"> Password is required </mat-error>
        <mat-error *ngIf="!formLogin.get('password').hasError('required') && formLogin.get('password').hasError('minlength')">
          {{ formLogin.get('password').getError('minlength').requiredLength }} symbols minimum.
          {{ formLogin.get('password').getError('minlength').actualLength }} symbols entered.
        </mat-error>
      </mat-form-field>
    </div>

    <div class="mb-3">
      <button
        mat-raised-button
        color="primary"
        class="submit-button"
        (click)="onLogin()"
        [disabled]="formLogin.invalid">
        LOGIN
      </button>
    </div>
  </form>

  <!--
  <form novalidate [formGroup]="formLogin" (ngSubmit)="onLogin()">

    <div class="row mb-3">
      <div class="col-4">
        <label for="inputEmailId" class="form-label">Email</label>
      </div>
      <div class="col-8">
        <input
          type="text"
          class="form-control"
          id="inputEmailId"
          formControlName="email"
          [ngClass]="{
                  'is-valid': formLogin.controls.email.valid && formLogin.controls.email.touched,
                  'is-invalid': formLogin.controls.email.invalid && formLogin.controls.email.touched
              }">
        <div
          *ngIf="!formLogin.get('email').valid && formLogin.get('email').touched"
          class="invalid-feedback">Email is required.</div>
        <div
          *ngIf="formLogin.get('email').errors?.email"
          class="invalid-feedback">Email is not valid.</div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-4">
        <label for="inputPasswordId" class="form-label">Password</label>
      </div>
      <div class="col-8">
        <input
          type="text"
          class="form-control"
          id="inputPasswordId"
          formControlName="password"
          [ngClass]="{
                  'is-valid': formLogin.controls.password.valid && formLogin.controls.password.touched,
                  'is-invalid': formLogin.controls.password.invalid && formLogin.controls.password.touched
              }">
        <div
          *ngIf="!formLogin.get('password').valid && formLogin.get('password').touched"
          class="invalid-feedback">Password is required.</div>
        <div
          *ngIf="formLogin.get('password').errors?.minlength"
          class="invalid-feedback">{{ formLogin.get('password').errors?.minlength.requiredLength }}
          symbols minimum.
          {{ formLogin.get('password').errors?.minlength.actualLength }} symbols entered.</div>

      </div>
    </div>

    <div class="row mb-3">
      <div class="col-4"></div>
      <div class="col-8">
        <button
          type="submit"
          class="btn btn-primary btn-lg"
          [disabled]="formLogin.invalid || formSubmitting"
        >Login</button>
      </div>
    </div>
  </form>
-->

  <pre>{{ formLogin.value | json }}</pre>
</section>
